<template>
  <mfe-base :error="error">
    <div
      ref="mounter"
      class="micro-front-end-container"
      data-sb-automation="merchant-app-inventory-optimization-mounter"
    >
      <Splash id="loader-splash" message="Loading..." />
    </div>
  </mfe-base>
</template>

<script>
import mfeMixin from '@/components/micro-front-ends/utils/mfeMixin'
import MfeBase from '@/components/micro-front-ends/utils/MfeBase.vue'

export default {
  name: 'InventoryOptimizationRoot',
  components: {
    MfeBase
  },
  mixins: [mfeMixin],
  async mounted () {
    try {
      const { mount } = await import('shipbob_inventory_optimization_ui/AppMount')

      await this.mountMfe(mount)
    } catch (error) {
      console.error('Error importing mount of shipbob_inventory_optimization_ui mfe', error)
      this.error = true
    }
  }
}
</script>
